var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rol && _vm.isPublic())?_c('Public'):(_vm.rol)?_c('Standard'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }